export default __webpack_public_path__ + "static/media/Diamond_Edge_large_7.1fb5aa7c.jpg";